import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import { TariffProvider } from '../../context/TariffContext';
import Navbar from '../../shared-components/navbar/Navbar';
import HyperPayApplePayComponent from '../applepay';
import Charger from '../charger';
import RedirectComponent from '../redirect';

/**
 * Global layout wrapper for all routes
 */
function GlobalLayout() {
  return (
    <div className="ev-global-layout">
      <div className="ev-main-content">
        <Outlet />
      </div>
    </div>
  );
}

/**
 * Entire layout with header
 */
function WrapperRoute() {
  return (
    <div className="ev-layout-wrap">
      <div className="ev-header">
        <Navbar />
      </div>
      <div className="ev-content">
        <Outlet />
      </div>
    </div>
  );
}

/**
 * Router component defining application routes
 * @returns The rendered router element.
 */
function Router() {
  return (
    <Routes>
      <Route element={<GlobalLayout />}>
        <Route path="/" element={<Navigate to="/charger" />} />
        <Route path="/charger" element={<RedirectComponent />} />
        <Route path="/apple-pay/demo" element={<HyperPayApplePayComponent />} />
        <Route
          path="/pay/:deviceId"
          element={
            <TariffProvider>
              <WrapperRoute />
            </TariffProvider>
          }>
          <Route index element={<Charger />} /> {/* Use 'index' for the default child route */}
        </Route>
      </Route>
    </Routes>
  );
}

export default Router;
